import { useTranslation } from "react-i18next";
import { Body1, Body2, Currency, Flex, Heading3, Heading4, HorizontalDivider, IconGroup, IconPerson, OutlinedCard, ProgressBar } from "@myphx-engineering/phx-design-system";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/spend-summary-card/SpendSummaryCard.tsx
const formatters = {
	max: (max, current) => /* @__PURE__ */ jsx(Heading4, { children: /* @__PURE__ */ jsx(Currency, { amount: Math.max(0, max - current) }) }),
	min: (min, current) => /* @__PURE__ */ jsx(Heading4, { children: /* @__PURE__ */ jsx(Currency, { amount: current - min }) })
};
const SpendSummaryCard = ({ deductible, outOfPocket, variant, title, subtitle, inactive, "data-testid": testId }) => {
	const { t } = useTranslation("phx-lib");
	const Icon = variant === "individual" ? IconPerson : IconGroup;
	const header = title ?? (variant === "individual" ? t("spendSummaryCard.individual") : t("spendSummaryCard.family"));
	const barColor = inactive ? "gray" : void 0;
	const backgroundBarColor = inactive ? "--mantine-color-gray-0" : void 0;
	return /* @__PURE__ */ jsx(OutlinedCard, {
		"data-testid": testId,
		children: /* @__PURE__ */ jsxs(Flex, {
			direction: "column",
			gap: "sm",
			children: [
				/* @__PURE__ */ jsxs(Flex, {
					gap: "xxs",
					children: [/* @__PURE__ */ jsx(Icon, {}), /* @__PURE__ */ jsxs(Flex, {
						gap: "xxxs",
						direction: "column",
						children: [/* @__PURE__ */ jsx(Heading3, { children: header }), subtitle ? /* @__PURE__ */ jsx(Body2, { children: subtitle }) : null]
					})]
				}),
				/* @__PURE__ */ jsx(HorizontalDivider, {}),
				/* @__PURE__ */ jsxs(Flex, {
					direction: "column",
					"data-testid": "deductible-amount-per-year",
					children: [/* @__PURE__ */ jsx(Body1, { children: t("spendSummaryCard.deductible") }), /* @__PURE__ */ jsxs(Heading4, { children: [/* @__PURE__ */ jsx(Currency, { amount: deductible.max }), t("spendSummaryCard.year")] })]
				}),
				/* @__PURE__ */ jsx(ProgressBar, {
					startLabel: t("spendSummaryCard.spent"),
					endLabel: t("spendSummaryCard.toGo"),
					max: deductible.max,
					maxFormatter: formatters.max,
					min: 0,
					minFormatter: formatters.min,
					value: Math.min(deductible.max, deductible.spent),
					color: barColor,
					backgroundColor: backgroundBarColor
				}),
				/* @__PURE__ */ jsxs(Flex, {
					direction: "column",
					mt: "0.5rem",
					"data-testid": "outOfPocket-amount-per-year",
					children: [/* @__PURE__ */ jsx(Body1, { children: t("spendSummaryCard.maxOutOfPocket") }), /* @__PURE__ */ jsxs(Heading4, { children: [/* @__PURE__ */ jsx(Currency, { amount: outOfPocket.max }), t("spendSummaryCard.year")] })]
				}),
				/* @__PURE__ */ jsx(ProgressBar, {
					startLabel: t("spendSummaryCard.spent"),
					endLabel: t("spendSummaryCard.toGo"),
					max: outOfPocket.max,
					maxFormatter: formatters.max,
					min: 0,
					minFormatter: formatters.min,
					value: Math.min(outOfPocket.max, outOfPocket.spent),
					color: barColor,
					backgroundColor: backgroundBarColor
				})
			]
		})
	});
};

//#endregion
export { SpendSummaryCard };